<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-6 col-sm-12 text-muted text-left">
        <p>{{ powered }}</p>
      </div>
      <div class="col-lg-6 col-sm-12 text-right">
        <app-social></app-social>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 text-muted text-center lead" style="font-size: 60%;">
        <a href="https://www.freepik.com/" target="_blank">Designed by Freepik</a>
      </div>
    </div>
  </div>
</template>

<script>
import Social from '@/components/parts/Social.vue'

export default {
  components: {
    AppSocial: Social,
  },
  data () {
    return {
      msg: '',
      powered: '© 2023 lab321 ltd. Все права защищены.'
    }
  }
}
</script>

<style scoped>
  .container {
    padding-top: 4rem;
    padding-bottom: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/parts/Footer.vue